import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';

export const checkInGuest = async (bookingId) => {
  const callable = httpsCallable(functions, 'checkInGuest');
  try {
    const { data } = await callable({ bookingId });
    return data;
  } catch (err) {
    throw new Error(err.message || 'Failed to check in this guest.');
  }
};

export const requestHostAccess = async (accessCode) => {
  const callable = httpsCallable(functions, 'requestHostAccess');
  try {
    const { data } = await callable({ accessCode });
    return data;
  } catch (err) {
    throw new Error(err.message || 'Failed to grant host access.');
  }
};
